import { GroupItem, GroupRequest } from "../types/groupItem";
import { CallResult, doApiDelete, doApiGet, doApiPatch, doApiPost } from "./Requests";
import { PaginationParameters, PaginationResult, toQueryParameters } from "./Pagination";
import { EmployeeGeneral } from "../types/employeeType";

export const groupsApi = {
  getGroups: async (
    pagination: PaginationParameters
  ): Promise<CallResult<PaginationResult<GroupItem>>> => {
    return await doApiGet<PaginationResult<GroupItem>>(
      `/api/companies/current/taxbenefitgroups?${toQueryParameters(pagination)}`
    );
  },

  getGroupMembers: async (
    groupId: number
  ): Promise<CallResult<EmployeeGeneral[]>> => {
    return await doApiGet<EmployeeGeneral[]>(
      `/api/companies/current/groups/${groupId}/members`
    );
  },

  getAllGroups: async (): Promise<CallResult<GroupItem[]>> => {
    return await doApiGet<GroupItem[]>("/api/companies/current/groups");
  },

  createGroup: async (
    groupData: Partial<GroupItem>
  ): Promise<CallResult<GroupItem>> => {
    return await doApiPost("/api/companies/current/groups", groupData);
  },

  editGroup: async (
    id: number,
    groupData: GroupRequest
  ): Promise<CallResult<GroupItem>> => {
    return await doApiPatch(`/api/companies/current/groups/${id}`, groupData);
  },

  deleteGroup: async (
    id: number
  ): Promise<CallResult<null>> => {
    return await doApiDelete(`/api/companies/current/groups/${id}`);
  },
};
